import { withTranslation } from "react-i18next";

import ReportList from './ReportList';

export default withTranslation()(ReportList);